import React from 'react';

interface LogoProps {
  className?: string;
  size?: number;
}

const Logo: React.FC<LogoProps> = ({ className = '', size = 40 }) => {
  return (
    <img 
      src="/logo.svg"
      alt="SecretMarket Logo"
      width={size}
      height={size}
      className={className}
    />
  );
};

export default Logo;